<div *ngIf="!isCalled" class="bg-th-yellow mt-0 container-fluid">
  <div class="d-flex justify-content-between align-content-center h-35">
    <i
      class="fa fa-arrow-left text-dark my-auto pointer"
      [routerLink]="['/']"
    ></i>

    <span class="my-auto f16 fw-bold me-2"> ردیاب‌های قطع </span>
  </div>
</div>

<main style="direction: rtl" class="px-2" [formGroup]="mdl_Request">
  <div class="row gx-0 gy-0 mt-4" style="gap: 10px">
    <div class="col-md-auto">
      <ng-persian-datepicker
        [uiTheme]="'gray'"
        [timeEnable]="false"
        [dateGregorianFormat]="'YYYY/MM/DD'"
        [dateInitValue]="true"
        [dateFormat]="'jYYYY/jMM/jDD'"
      >
        <input
          type="text"
          formControlName="strDate"
          class="form-control text-end"
        />
      </ng-persian-datepicker>
    </div>
    <div class="col-12 col-md-auto d-flex align-items-center">
      <button class="btn btn-primary w-100" (click)="fetchOfflineCars()">
        بررسی
      </button>
    </div>
  </div>
  <div
    [ngClass]="isCalled ? 'mt-1' : 'border border-2 mt-3 p-2'"
    class="container-fluid row gx-2 gy-2"
  >
    <!-- جستجو -->
    <div class="col-md-8 col-12">
      <input
        type="text"
        class="w-100 form-control"
        placeholder="جستجو کنید ..."
        (input)="filter_Result($event.target)"
      />
    </div>

    <!-- ارسال پیام -->
    <div *ngIf="bSendPush" class="col-12 col-md-auto d-flex align-items-center">
      <button class="btn btn-outline-primary w-100" (click)="openPush_User()">
        ارسال پیام
      </button>
    </div>

    <!-- خروجی اکسل -->
    <div class="col-12 col-md-auto d-flex align-items-center">
      <button
        class="btn btn-success w-100"
        (click)="exportexcel('Export_Excel')"
      >
        خروجی اکسل
      </button>
    </div>

    <!-- جدول اطلاعات -->
    <div
      class="border border-2 mt-2"
      [ngClass]="isCalled ? 'limit-section' : 'section'"
    >
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col" class="">#</th>

            <th
              scope="col"
              class="pointer"
              (click)="onCheckbox_Car('', '', 'select-all')"
            >
              انتخاب
            </th>

            <th scope="col" class="pointer">نام ردیاب</th>

            <th scope="col" class="">پلاک</th>

            <th scope="col" class="pointer">شماره راننده</th>

            <th scope="col" class="">شماره سیمکارت</th>

            <th scope="col" class="">آخرین لاگ</th>

            <th scope="col" class="">تاریخ پایان اعتبار</th>

            <th scope="col" class="pointer">حوزه خدمت</th>
          </tr>
        </thead>

        <tbody>
          <tr
            class="f14 text-center pointer"
            *ngFor="let item of lst_Expired; let i = index"
            (click)="changeRoute(item)"
          >
            <th class="text-dark">{{ i + 1 | faNum }}</th>

            <td class="">
              <input
                type="checkbox"
                [checked]="item?.bChosen"
                (click)="onCheckbox_Car($event, i)"
              />
            </td>

            <td>{{ item.strFullName | faNum }}</td>

            <td>{{ item.strVehicleNo | faNum }}</td>

            <td>{{ item.strMobile | faNum }}</td>

            <td>{{ item.strCellNo | faNum }}</td>

            <td>{{ item.strDateTime | faNum }}</td>

            <td>{{ item.strValidDate | faNum }}</td>

            <td>{{ item.strMobileDomain_strComment | faNum }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- ارسال پوش -->
  <div
    class="modal fade"
    id="Push_Modal"
    tabindex="-1"
    aria-labelledby=""
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title ms-0">ارسال پیام به راننده</h5>

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body" [formGroup]="mdl_Request">
          <ng-container *ngIf="mdl_Request.get('iPushType')?.value == 0">
            <div class="row gx-0 gy-0">
              <div
                class="col-12 col-md-6 px-2"
                (click)="mdl_Request.get('iPushType').setValue('2')"
              >
                <div
                  class="pointer bg-success w-100 p-1 py-2 d-flex flex-column justify-content-center align-items-center border border-2"
                >
                  <span class="text-white"> صدا </span>

                  <i
                    class="fa fa-microphone fa-lg my-2 text-white"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>

              <div
                class="col-12 col-md-6 px-2"
                (click)="mdl_Request.get('iPushType').setValue('1')"
              >
                <div
                  class="pointer bg-primary w-100 p-1 py-2 d-flex flex-column justify-content-center align-items-center border border-2"
                >
                  <span class="text-white"> پیام </span>

                  <i
                    class="fa fa-envelope-o fa-lg text-white my-2"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- متن -->

          <ng-container *ngIf="mdl_Request.get('iPushType')?.value == 1">
            <!-- عنوان -->

            <div class="position-relative col-12 p-2">
              <label class="mb-2 text-muted" style="top: -5px"> عنوان </label>

              <input
                class="form-control p-2 text-center"
                formControlName="strTitle"
              />
            </div>

            <!-- متن پیام -->

            <div class="col-12 p-2">
              <textarea
                style="height: 120px; resize: none"
                formControlName="strMessage"
                placeholder="متن پیام خود را وارد کنید"
                class="form-control"
              >
              </textarea>
            </div>

            <!-- ارسال پیامک -->

            <div class="col-12 p-2" *ngIf="bSendPayamak">
              <div
                class="form-check form-switch m-0 d-flex align-items-center col-12 px-2"
              >
                <input
                  class="form-check-input m-0"
                  type="checkbox"
                  id="bSMS"
                  formControlName="bSMS"
                />

                <label
                  class="form-check-label pointer text-muted me-2"
                  for="bSMS"
                >
                  پیامک
                </label>
              </div>
            </div>
          </ng-container>

          <!-- صدا -->

          <ng-container *ngIf="mdl_Request.get('iPushType')?.value == 2">
            <div class="col-12 p-2">
              <!-- عنوان -->

              <div class="position-relative col-12 p-2">
                <label class="mb-2 text-muted" style="top: -5px"> عنوان </label>

                <input
                  class="form-control p-2 text-center"
                  formControlName="strTitle"
                />
              </div>
            </div>

            <div class="col-12 p-2">
              <!-- start Recording -->

              <ng-container *ngIf="!isAudioRecording && !isAudioRecorded()">
                <button
                  class="btn btn-secondary w-100"
                  (click)="startAudioRecording()"
                >
                  <i class="fa fa-microphone me-1" aria-hidden="true"></i>

                  <span class="text-warning"> {{ "*" }} </span>

                  ضبط صدا

                  <span> {{ "( اجباری )" }} </span>
                </button>
              </ng-container>

              <!-- stop Recording -->

              <ng-container *ngIf="isAudioRecording && !isAudioRecorded()">
                <button
                  class="btn btn-secondary w-100"
                  (click)="stopAudioRecording()"
                >
                  <i class="fa fa-square me-1" aria-hidden="true"></i>

                  توقف صدا

                  <span> {{ audioRecordedTime | faNum }} </span>
                </button>
              </ng-container>

              <!-- play Recording -->

              <ng-container *ngIf="!isAudioRecording && isAudioRecorded()">
                <div class="position-relative">
                  <div class="audio-icon col-2" *ngIf="isAudioRecorded()">
                    <button
                      class="btn"
                      style="background: #f1f3f4"
                      (click)="clearAudioRecordedData()"
                    >
                      <i class="fa fa-trash fa-lg" aria-hidden="true"></i>
                    </button>
                  </div>

                  <div *ngIf="audioSrcUrl != ''">
                    <audio controls class="w-100 rounded">
                      <source [src]="audioSrcUrl" type="audio/mp3" />

                      Your browser does not support the audio element.
                    </audio>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <div class="modal-footer" style="direction: ltr">
          <ng-container *ngIf="mdl_Request.get('iPushType')?.value != 0">
            <button
              class="btn btn-outline-secondary"
              (click)="mdl_Request.get('iPushType').setValue('0')"
            >
              بازگشت
            </button>

            <button
              type="button"
              class="btn btn-success"
              (click)="sendPush_4Users()"
            >
              ارسال پیام
            </button>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</main>
